import { ColorSchemeName, Linking } from 'react-native';
import { t } from 'i18next';
import { CommonActions } from '@react-navigation/native';
import linkingConfig from '../navigation/linkingConfig';
import { ThemeOption } from '../resources/interfaces';
import { isIos, isNative } from './responsive';

export const getInitialRoutes = () => {
  const screensConfig = linkingConfig.config?.screens || {};

  return (
    Object.values(screensConfig)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .map((screen) => screen.initialRouteName)
      .filter(Boolean)
  );
};

export const handleHTMLLinkPress = (href, navigation, linkTo) => {
  const initialRoutes = getInitialRoutes();
  if (!href) return;

  if (href.startsWith(process.env.EXPO_PUBLIC_APP_DOMAIN)) {
    // Belső link → Navigálás az alkalmazáson belül
    // Távolítsa el a domain-t, és biztosítsa, hogy az útvonal '/'-tal kezdődjön
    let internalPath = href.replace(process.env.EXPO_PUBLIC_APP_DOMAIN, '');
    if (!internalPath.startsWith('/')) {
      internalPath = '/' + internalPath;
    }

    // Ha az internalPath egy initial route, akkor reseteljük a stack-et
    if (initialRoutes.includes(internalPath.replace('/', ''))) {
      navigation.dispatch({
        ...CommonActions.navigate(internalPath.replace('/', '')),
      });
    } else {
      linkTo(internalPath);
    }
  } else {
    handleLinkPress(href);
  }
};

export const getOppositeColorScheme = (colorScheme: ColorSchemeName | ThemeOption) => {
  return Object.values(ThemeOption).find((c) => c !== colorScheme);
};

export const distributeElements = <T>(inputArray: T[], columns): T[][] => {
  const output = Array.from({ length: columns }, () => []);

  for (let i = 0; i < inputArray.length; i++) {
    const targetIndex = i % columns;
    output[targetIndex].push(inputArray[i]);
  }

  return output;
};

export const handleLinkPress = (url: string) => {
  if (isNative) {
    Linking.openURL(url);
  } else {
    if (typeof window !== 'undefined') {
      // We are running in a web environment
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        newWindow.focus();
      }
    } else {
      // We are running in a React Native environment
      Linking.openURL(url);
    }
  }
};

export const addressPattern =
  /\b(street|utca|u\.|road|út|ave(nue)?|sugárút|square|tér|blvd|boulevard|krt\.|körút|alley|köz|quay|rakpart|promenade|sétány|park)\b\s?\d*|u\.\s\d+/i;

export const openInMaps = async (location, showActionSheetWithOptions, setMessage) => {
  const options = [
    {
      translation: t('events:open_in_google_maps'),
      url: `comgooglemaps://?q=${encodeURIComponent(location)}`,
    },
    isIos && {
      translation: t('events:open_in_maps'),
      url: `http://maps.apple.com/?q=${encodeURIComponent(location)}`,
    },
    {
      translation: t('extreme_events:cancel'),
    },
  ].filter(Boolean);

  const cancelButtonIndex = options.length - 1;

  if (isNative) {
    showActionSheetWithOptions(
      {
        options: options.map((option) => option.translation),
        cancelButtonIndex,
      },
      async (buttonIndex) => {
        if (buttonIndex === cancelButtonIndex) {
          return;
        }

        try {
          await Linking.openURL(options[buttonIndex].url);
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
          try {
            await Linking.openURL(
              `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`,
            );
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
          } catch (googleMapsWebError) {
            setMessage({ message: t('error_messages:default'), type: 'error' });
          }
        }
      },
    );
  } else {
    handleLinkPress(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`,
    );
  }
};
